// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.presize-root .distribution-column:hover .editable-cell-value {
  cursor: pointer;
  border-color: #e3e3e3;
}
.presize-root .ant-form-item-control-input {
  min-height: auto;
}
.presize-root .ant-form-item-explain {
  display: none;
}
.presize-root .editable-cell-input {
  border-radius: 4px;
  text-align: right;
  padding: 0 14px 1px 2px;
}
.presize-root .editable-cell-input[value='0'],
.presize-root .editable-cell-input[value='0.0'] {
  color: #a2a3a8;
}
.presize-root .percentage-tag {
  font-size: 69%;
  position: absolute;
  top: 12px;
  right: 6px;
}
.presize-root .reference-mismatched {
  font-weight: 600;
}
/*# sourceMappingURL=EditableCell.css.map */`, "",{"version":3,"sources":["webpack://./EditableCell.less","webpack://./src/components/Matrices/Matrix/EditableCell/EditableCell.less"],"names":[],"mappings":"AAAA;EAEE,eAAA;EACA,qBAAA;ACAF;ADHA;EAME,gBAAA;ACAF;ADNA;EASE,aAAA;ACAF;ADTA;EAYE,kBAAA;EACA,iBAAA;EACA,uBAAA;ACAF;ADEE;;EAEE,cAAA;ACAJ;ADlBA;EAsBE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;ACDF;ADxBA;EA6BE,gBAAA;ACFF;AACA,2CAA2C","sourcesContent":[".presize-root { \n .distribution-column:hover .editable-cell-value {\n  cursor: pointer;\n  border-color: #e3e3e3;\n}\n.ant-form-item-control-input {\n  min-height: auto;\n}\n.ant-form-item-explain {\n  display: none;\n}\n.editable-cell-input {\n  border-radius: 4px;\n  text-align: right;\n  padding: 0 14px 1px 2px;\n\n  &[value='0'],\n  &[value='0.0']{\n    color: #a2a3a8;\n  }\n}\n.percentage-tag {\n  font-size: 69%;\n  position: absolute;\n  top: 12px;\n  right: 6px\n}\n\n.reference-mismatched {\n  font-weight: 600;\n}\n\n \n}",".presize-root .distribution-column:hover .editable-cell-value {\n  cursor: pointer;\n  border-color: #e3e3e3;\n}\n.presize-root .ant-form-item-control-input {\n  min-height: auto;\n}\n.presize-root .ant-form-item-explain {\n  display: none;\n}\n.presize-root .editable-cell-input {\n  border-radius: 4px;\n  text-align: right;\n  padding: 0 14px 1px 2px;\n}\n.presize-root .editable-cell-input[value='0'],\n.presize-root .editable-cell-input[value='0.0'] {\n  color: #a2a3a8;\n}\n.presize-root .percentage-tag {\n  font-size: 69%;\n  position: absolute;\n  top: 12px;\n  right: 6px;\n}\n.presize-root .reference-mismatched {\n  font-weight: 600;\n}\n/*# sourceMappingURL=EditableCell.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
